// extracted by mini-css-extract-plugin
export default {"scrollBtn":"BackToTop_scrollBtn__jPHPh","hidden":"BackToTop_hidden__5WXCI"};